import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center w-full space-y-10 pb-5" }

import UserReview from "@/components/UserReview.vue";
import {PropType} from "vue";
import {ReviewInterface} from "@/interfaces/ReviewInterface";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserReviewSheet',
  props: {
  review: {
    type: Object as PropType<ReviewInterface>,
    required: true
  }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UserReview, {
      class: "w-full !border-b-0",
      review: __props.review
    }, null, 8, ["review"])
  ]))
}
}

})